import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=eee59b30&scoped=true&"
import script from "./ui-textarea.vue?vue&type=script&lang=ts&"
export * from "./ui-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./ui-textarea.vue?vue&type=style&index=0&id=eee59b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee59b30",
  null
  
)

export default component.exports